import React from "react";

import GlobalApi from "./../../Global";
import refresh_token from "./../../Global/refresh_token";
import Spinner from "./../../Global/Spinner";
import {
  Paper,
  Typography,
  Table,
  TableBody,
  TableRow,
  TableCell,
  Container,
  Button,
} from "@material-ui/core";
import _ from "lodash";
import { useHistory } from "react-router-dom";
import TextInputCustom from "./TextInput";
let pricing_json = [
  {
    title: "Inspection",
    pricings: [
      {
        title: "Inspection Limit",
        free: "8",
        medium: "unlimited",
        premium: "unlimited",
        type: "number",
      },
      {
        title: "PDF inspection exports",
        free: "12",
        medium: "unlimited",
        premium: "unlimited",
        label: "per month",
        type: "number",
      },
      {
        title: "Create inspection templates",
        free: "unlimited",
        medium: "unlimited",
        premium: "unlimited",
        type: "number",
      },
      {
        title: "Access to best practice Public Library Templates",
        free: "yes",
        medium: "yes",
        premium: "yes",
        type: "yes_limited",
      },
      {
        title: "Track Items that are failing",
        free: "limited",
        medium: "yes",
        premium: "yes",
        type: "yes_limited",
      },
      {
        title: "Schedule inspection",
        free: "limited",
        medium: "yes",
        premium: "yes",
        type: "yes_limited",
      },
    ],
  },
];

export default function Notification() {
  const history = useHistory();
  const [pricing, setPricing] = React.useState({});
  const [editIndex, setEditIndex] = React.useState("");
  const [pricingData, setPricingData] = React.useState(pricing_json);
  function getPricing() {
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data?.token;
    let params = {
      payment_type: "pound",
    };
    // console.log(data.user_id);
    let query = Object.keys(params)
      .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
      .join("&");

    fetch(GlobalApi + "/PricingModule/get_all_pricing_modules?" + query, {
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    })
      .then((responseJson) => responseJson.json())
      .then(async (response) => {
        if (response.status === "Success") {
          let grouped_res = await _.groupBy(response.data, (v) => v.title);

          let final_grouped_res = {};
          await Object.keys(grouped_res).map(async (key, mainI) => {
            let obj = await _.groupBy(
              grouped_res[key][0]?.PricingFeatures,
              (v) => v.title
            );
            final_grouped_res[key] = obj;
            if (mainI === Object.keys(grouped_res).length - 1) {
              await Object.keys(final_grouped_res).map(async (key1) => {
                await Object.keys(final_grouped_res[key1]).map(async (key2) => {
                  let obj = await _.groupBy(
                    final_grouped_res[key1][key2],
                    (v) => v?.Package?.title
                  );
                  final_grouped_res[key1][key2] = obj;
                });
              });
              setPricing(final_grouped_res);
            }
          });
        } else if (
          response.error === "jwt expired" ||
          response.error === "invalid token" ||
          response.error === "invalid signature" ||
          response.error === "Unexpected token"
        ) {
          let status = await refresh_token();
          if (status) {
            getPricing();
          }
        }
      })
      .catch((error) => console.log(error.message));
  }

  React.useEffect(() => {
    getPricing();
  }, []);

  function handleChange(e) {
    let { value, name } = e.target;
    let indexStr = editIndex.split("-");

   
    
    let obj = pricing;
    obj[indexStr[0]][indexStr[1]][name][0]["value"] = value;

    console.log({...obj})
    setPricingData({...obj});
  }

  function handleEdit(index, childIndex) {
    console.log(pricing[index][childIndex]);

    setEditIndex(`${index}-${childIndex}`);
  }

  async function handleEditSubmit(index, childIndex) {
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data?.token;
    await Object.keys(pricing[index][childIndex]).map(async keys => {
        await pricing[index][childIndex][keys].map(async value => {
            await fetch(GlobalApi + "/PricingFeature/edit_pricing_feature", {
                method: "post",
                headers: new Headers({
                  Authorization: "Bearer " + token,
                  "Content-Type": "application/json",
                }),
                body: JSON.stringify({
                  pricing_feature_id: value.id,
                  value: value.value,
                }),
              })
        })
    })

    setEditIndex(``);
  }

  if (pricing === null) {
    return <div style={{ padding:'20px'}}><Spinner/></div>;
  } else {
    return (
      <div style={{ padding: 10, textAlign: "left" }}>
        <Typography variant="h3">Pricing</Typography>

        <Container>
          <Table padding="checkbox" component={Paper} style={{ margin: 10 }}>
            <TableBody>
              {Object.keys(pricing).map((key, i) => {
                return [
                  <TableRow>
                    <TableCell colSpan={5}>
                      <Typography variant="h4">{key}</Typography>
                    </TableCell>
                  </TableRow>,
                  Object.keys(pricing[key]).map((valKey, valI) => {
                    let cond = `${key}-${valKey}`;
                    // console.log(pricing[key][valKey]);
                    return (
                      <TableRow key={cond}>
                        <TableCell style={{ minWidth: 250 }}>
                          {valKey}
                        </TableCell>
                        <TableCell>
                          {editIndex === cond ? (
                            <TextInputCustom
                              state="Free"
                              onChange={handleChange}
                              value={pricing[key][valKey]["Free"][0].value}
                            />
                          ) : (
                            pricing[key][valKey]["Free"][0].value + " " + pricing[key][valKey]["Free"][0].label
                          )}
                        </TableCell>
                        <TableCell>
                          {" "}
                          {editIndex === cond ? (
                            <TextInputCustom
                              state="Small / Medium"
                              onChange={handleChange}
                              value={pricing[key][valKey]["Small / Medium"][0].value}
                            />
                          ) : (
                            pricing[key][valKey]["Small / Medium"][0].value + " " + pricing[key][valKey]["Small / Medium"][0].label
                          )}
                        </TableCell>
                        <TableCell>
                          {" "}
                          {editIndex === cond ? (
                            <TextInputCustom
                              state="Enterprise"
                              onChange={handleChange}
                              value={pricing[key][valKey]["Enterprise"][0].value}
                            />
                          ) : (
                            pricing[key][valKey]["Enterprise"][0].value + " " + pricing[key][valKey]["Small / Medium"][0].label
                          )}
                        </TableCell>
                        <TableCell>
                          {editIndex === `${key}-${valKey}` ? (
                            <Button onClick={() => handleEditSubmit(key, valKey)}>
                              Done
                            </Button>
                          ) : (
                            <Button onClick={() => handleEdit(key, valKey)}>
                              Edit
                            </Button>
                          )}
                        </TableCell>
                      </TableRow>
                    );
                  }),
                ];
              })}
            </TableBody>
          </Table>
        </Container>
      </div>
    );
  }
}
